
module.exports = {"attributes":{"width":"36","height":"23","viewBox":"0 0 36 23"},"content":"<path d=\"M3.2 0L0 3.3v16.4L3.3 23H22V0H3.2m30.4 1L25 9v5l8.6 8H36V1h-2.4\"/>"}
var desvg = require('@kossnocorp/desvg/react')
module.exports = desvg(module.exports)
